export default "__VITE_ASSET__ebdee831__"